import { ViewStyle, ScrollView } from "react-native";

// Data
import { useSelector } from "react-redux";
import { selectStories } from "../../redux/mainSlice";
import { nanoid } from "@reduxjs/toolkit";

// Components
import StoryIcon from "./StoryIcon";

// Styles
import { Spacing } from "../../styles";

const Stories = ({ style }: { style?: ViewStyle }) => {
  const stories = useSelector(selectStories);

  return (
    <ScrollView
      horizontal
      style={[
        {
          flexDirection: "row",
          paddingTop: Spacing.page,
          paddingLeft: Spacing.page,
          marginBottom: 25,
        },
        style,
      ]}
      showsHorizontalScrollIndicator={false}
    >
      {stories.data.map((s) => (
        <StoryIcon entity={s.entity} key={nanoid()} insights={s.insights} />
      ))}
    </ScrollView>
  );
};

export default Stories;
